export function Encrypt(input:string){
    let result="";
    for(let i =0;i<input.length;i++){
        result=result+String.fromCharCode(input.charCodeAt(i)+10-2*i);
    }
    return result;
}

import md5 from 'js-md5';
export function MD5Encrypt(input:string){
    return md5(input);
}

const S4 = function() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };

export function NewGuid():string{
    return (S4() + S4() +'-' +S4() +'-' +S4() +'-' +S4() +'-' +S4() +S4() +S4()
    );
}


export function SqlEncrypt(){

}

export function DefaultEncrypt(){

}

export function GZHCheck(){
    
}